import type { ReactNode } from 'react';
import { tv } from 'tailwind-variants';

type BadgeProps = {
  children?: ReactNode;
  content?: ReactNode;
  show?: boolean;
  classNames?: {
    container?: string;
    badge?: string;
  };
  dot?: boolean;
  max?: number;
};

export const badgeStyles = tv({
  slots: {
    container: 'relative',
    badge:
      'flex min-h-5 min-w-5 items-center justify-center rounded-full bg-primary-800 p-0.5 text-xs text-neutral-0',
  },
  variants: {
    hasChildren: {
      true: {
        badge: 'absolute -right-1 -top-1',
      },
    },
    dot: {
      true: {
        badge: 'min-h-3 min-w-3 p-0',
      },
    },
  },
});

export function Badge({
  classNames = {},
  content,
  children,
  show = true,
  dot,
  max = 99,
}: BadgeProps) {
  const hasChildren = !!children;

  const styles = badgeStyles({ dot, hasChildren });

  const isNumber = typeof content === 'number';

  const badgeContent = isNumber
    ? content > max
      ? `${max}+`
      : content
    : content;

  return (
    <div className={styles.container({ className: classNames.container })}>
      {children}
      {show && (
        <span className={styles.badge({ className: classNames.badge })}>
          {dot ? null : badgeContent}
        </span>
      )}
    </div>
  );
}
